import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { GetOnClick } from './helpers';

import '@src/css/metlife_css/buttons.scss';

/**
 * ## StandardLink
 *
 * Standard link with MetLife UX Styles
 * @param {object} appHistory - Redux app history - or - push function
 * @param {function} pushHistory - Function passed down appHistory.push()
 * @param {function} className - Additional classNames
 * Used to when Component alter history before it is pushed.
 * @param {string} text - display text string
 * @param {string} link - href string
 * @param {boolean} External - If true this is an external links
 * @param {string} modifyAppHistoryLink - Modify the directory that appHistory pushed to
 */

export const StandardButton = (props) => {
    const {
        appHistory,
        className,
        text,
        link,
        pushHistory,
        modifyAppHistoryLink = '/',
        External = false,
    } = props;

    const classNames = classnames('ml-button-primary', className);

    // If appHistory exist and it includes
    if (pushHistory || appHistory) {
        return (
            <a
                className={classNames}
                onClick={GetOnClick({
                    appHistory,
                    link,
                    pushHistory,
                    modifyAppHistoryLink,
                })}
            >
                {text}
            </a>
        );
    }

    // If not appHistory is set and External is true
    if (External) {
        return (
            <a
                className={classNames}
                target="_blank"
                rel="noopener noreferrer"
                href={link}
            >
                {text}
            </a>
        );
    }

    // Else the page will push history but refresh page requesting
    // all the script pages again
    return (
        <a
            className={classNames}
            href={`${link}`}
        >
            {text}
        </a>
    );
};

StandardButton.propTypes = {
    appHistory: PropTypes.object,
    className: PropTypes.string,
    text: PropTypes.string,
    link: PropTypes.string,
    pushHistory: PropTypes.func,
    modifyAppHistoryLink: PropTypes.string,
    External: PropTypes.string,
};
